import { InferenceStatus, useInferenceQueue } from "@rapid/store";

export const useIsGeneratingPredictions = (uploadIntentId?: string) => {
    const inferenceQueue = useInferenceQueue();

    const inferenceQueueItems = uploadIntentId
        ? [inferenceQueue.get(uploadIntentId)]
        : Array.from(inferenceQueue.values());

    return inferenceQueueItems.some(
        (item) =>
            item &&
            (item.status === InferenceStatus.QUEUED || item.status === InferenceStatus.INFERRING)
    );
};
